import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material';
import { Box, Tooltip, IconButton, Button } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';

import Input from '../../../../../form/Input'; // ajuste o path se precisar

export default function AssinaturasTabPanel({
    // UI/Tema
    theme,

    // môdulo headless
    module,
    // contexto
    operacao,
    // ações de linha
    onCancelarRow,

    // permissões
    podeCancelarItem,
}) {
    const { main, draft, list, mrt, flags, actions } = module || {};

    const assinatura = draft?.value || {};

    const data = list?.items || [];
    const rowCount = list?.rowCount || 0;

    const {
        change: onChangeAssinatura = () => {},
        clear: onLimparAssinatura = () => {},
        submitDraft: onAssinar = async () => {},
        remove: removerAssinatura = async () => {},
    } = actions || {};

    const { isSaving = false, canSign = false } = flags || {};

    const {
        state: {
            columnFilterFns = {},
            columnFilters = [],
            globalFilter = '',
            pagination = { pageIndex: 0, pageSize: 10 },
            sorting = [],
        } = {},
        setters: {
            setColumnFilterFnsMode = () => {},
            setColumnFilters = () => {},
            setGlobalFilter = () => {},
            setPagination = () => {},
            setSorting = () => {},
        } = {},
        flags: { isLoading = false, isRefetching = false, isError = false } = {},
    } = mrt || {};

    const getRowId = (row) => row.uuid ?? row.id;
    const manual = true;
    const columns = useMemo(
        () => [
            {
                id: 'assinatura',
                header: `Assinaturas no movimento ${operacao?.descricao} - ${operacao?.sigla}`,
                columns: [
                    {
                        accessorKey: 'Pessoa.descricao',
                        header: 'Responsável pela assinatura',

                        muiTableBodyCellProps: ({ row }) => ({
                            align: 'left',
                            onClick: () => {
                                console.info(row.original);
                            },
                        }),
                    },
                    {
                        accessorKey: 'papel.descricao',
                        header: 'Cargo / Papel',
                    },
                ],
            },

            //column definitions...
        ],
        [operacao] //getCommonEditTextFieldProps
    );
    return (
        <div style={{ margin: '1em' }}>
            {/* Linha de inputs */}
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                <Input
                    text="Usuário"
                    type="text"
                    name="novaAssinatura.usuario"
                    title="Digite o nome do usuário"
                    placeholder="Usuário"
                    handleOnChange={onChangeAssinatura}
                    value={assinatura?.usuario || ''}
                />

                <Input
                    text="Senha"
                    type="password"
                    name="novaAssinatura.senha"
                    title="Digite a senha para confirmar a assinatura"
                    placeholder="senha"
                    handleOnChange={onChangeAssinatura}
                    readonly={!assinatura?.usuario}
                    value={assinatura.senha}
                    autocompelte="new-password"
                    style={{ display: 'none' }}
                />

                <Button
                    variant="contained"
                    color="inherit"
                    onClick={onLimparAssinatura}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    Limpar
                </Button>

                <Button
                    variant="contained"
                    color={String(assinatura?.funcao || '')?.toLowerCase() === 'cancelar' ? 'error' : 'info'}
                    onClick={onAssinar}
                    disabled={!canSign || isSaving}
                    style={{ marginLeft: '10px', minWidth: '80px', fontSize: '14px' }}
                >
                    {isSaving ? 'Processando...' : assinatura?.funcao || 'Assinar'}
                </Button>
            </div>

            {/* Grid */}
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': { muiTableHeadCellProps: { align: 'center' }, size: 100 },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true,
                            enableResizing: true,
                            muiTableHeadCellProps: { sx: { fontSize: '1.2rem' } },
                        },
                        'mrt-row-select': { enableColumnActions: true, enableHiding: true, size: 50 },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="right" title="Cancelar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => onCancelarRow(row.original)}
                                        disabled={!podeCancelarItem}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    columns={columns}
                    data={data}
                    rowCount={rowCount}
                    getRowId={getRowId}
                    manualPagination={!!manual}
                    manualSorting={!!manual}
                    manualFiltering={!!manual}
                    muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data' } : undefined}
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFilterFnsMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    initialState={{ showColumnFilters: true, density: 'compact' }}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    positionExpandColumn="first"
                    positionActionsColumn="first"
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
}
